import cn from "../../lib/classnames";
import React from "react";
import styles from "./BoxLink.module.css";
import {Link} from "react-router-dom";

type Props = {
    to: string;
    label: string;
    className?: string;
};

export default function BoxLink(props: Props) {
    return (
        <Link
            target="_blank"
            aria-labelledby="label"
            className={cn(styles.link, props.className)}
            to={props.to}
        >
            <div aria-hidden="true" className={styles.plusSign}>
                +
            </div>
            <div id="label" className={styles.label}>
                {props.label}
            </div>
        </Link>
    );
}
